<script>
import CreateOrUpdateDistributionGroupsPopup from '@/popups/distribution-group/create-or-update';
import UpdateDistributionGroupUsersPopup from '@/popups/distribution-group/update-users';
import { ElParticipants, ElGroupAvatar } from '@/components/elements/_index';

export default {
  components: {
    ElParticipants,
    ElGroupAvatar,
  },

  mounted() {
    this.readDistributionGroups();
  },

  methods: {
    MoveRight(userId) {
      this.newDistributionGroupUsers.push(userId);
    },

    MoveLeft(userId) {
      this.newDistributionGroupUsers = this.newDistributionGroupUsers.filter(id => id !== userId);
    },

    readDistributionGroups() {
      if (!this.workspace) {
        return;
      }

      this.$store.dispatch('distributionGroup/readAll', { workspace_id: this.workspace.id });
    },

    createDistributionGroup() {
      this.$modal.show(CreateOrUpdateDistributionGroupsPopup, { action: 'create' }, { adaptive: true, height: 'auto', width: '600', scrollable: true });
    },

    updateDistributionGroupUsers(group) {
      this.$modal.show(UpdateDistributionGroupUsersPopup, { group: group }, { adaptive: true, height: 'auto', width: '600', scrollable: true });
    },

    remove(groupId) {
      this.$store.dispatch('distributionGroup/delete', { workspace_id: this.workspace.id, group_id: groupId });

      this.$store.dispatch('distributionGroup/readAll', { workspace_id: this.workspace.id });
    },
  },

  computed: {
    distributionGroups() {
      return this.$store.getters['distributionGroup/all'];
    },

    workspace() {
      return this.$store.getters['workspace/current'];
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center justify-content-center mb-32">
        <h2 class="mb-0 fw-b fs-24">{{ $t(`user.index.distribution_groups`) }}</h2>
        <button @click="createDistributionGroup()" class="btn btn-primary d-flex justify-content-center btn-inline ml-auto">
          <i class="fal fa-plus my-auto mr-3"></i>
          Toevoegen
        </button>
      </div>
      <div v-if="distributionGroups.length === 0" class="empty-holder">
        Nog geen Distributiegroepen aangemaakt.
      </div>
      <div v-else>
        <div v-for="distributionGroup in distributionGroups" :key="distributionGroup.id" class="d-flex flex-row justify-content-between align-items-center list border-bottom pb-4 mb-4">
          <div class="d-flex align-items-center justify-content-center">
            <ElGroupAvatar :group="distributionGroup" class="mr-8" size="a-40" />
            <div>
              <h3 class="mb-1 fw-b fs-15">{{ distributionGroup.title }}</h3>
              <p class="text-muted mb-0">{{ distributionGroup.subtitle }}</p>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <ElParticipants :users="distributionGroup.users" :canEdit="false" />
            <button class="btn ml-15 btn-outline-primary" @click="updateDistributionGroupUsers(distributionGroup)">
              <i class="fal fa-pencil my-auto"></i>
            </button>
            <button class="btn btn-outline-danger ml-15" @click.stop="remove(distributionGroup.id)">
              <i class="fal fa-trash my-auto"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.empty-holder {
  padding: 16px;
  border-radius: 4px;
  margin-top: 16px;
  background: whitesmoke !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.list:last-child {
  border-bottom: none !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}
</style>
